import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import './ModalVisibilidade.scss'

import Switch from '@material-ui/core/Switch';
import Modal from '@material-ui/core/Modal';

import fechar from '../../img/fechar.svg'
import lupa from '../../img/busca.svg'

const PurpleSwitch = withStyles({
    switchBase: {
        color: 'white',
        '&$checked': {
            color: 'white',

        },
        '&$checked + $track': {
            backgroundColor: '#0D84FF',
            opacity: 1
        },
    },
    checked: {},
    track: {},
})(Switch);


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        borderRadius: 15,
        padding: '18px 0px',
        width: 360,
        maxHeight: 388,
    },
}));


const a = [
    {
        id: 1,
        name: 'saudação'
    }, {
        id: 2,
        name: 'saudação'
    }, {
        id: 3,
        name: 'saudação'
    }, {
        id: 4,
        name: 'saudação'
    }, {
        id: 5,
        name: 'saudação'
    }, {
        id: 6,
        name: 'saudação'
    }, {
        id: 7,
        name: 'saudação'
    }, {
        id: 8,
        name: 'saudação'
    }, {
        id: 9,
        name: 'saudação'
    },
]

export default function ModalVisibilidade({ handleVisibilit, open }) {
    const classes = useStyles();

    const [isCheck, setIsCheck] = useState(false);
    const [selectCheck, setSelectCheck] = useState([])

    
    const selectAll = (e) => {
        
        if (e.target.checked) {
            setSelectCheck(a)
        } else {
            setSelectCheck([])
        }
        setIsCheck(!isCheck)
    }

    const onChangeCheck = (e, checkItem) => {
        if (e.target.checked) {
            setSelectCheck([...selectCheck, checkItem])
        } else {
            setSelectCheck(selectCheck.filter(check => checkItem.id !== check.id))
        }
    }
    

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={open}
            onClose={handleVisibilit}
            className={classes.modal}
        >
            <div className={classes.paper}>
                <div className="mod-header-all">
                    <div className="modal-header-visibility">
                        <span>Ativar IA em bloco</span>
                        <img onClick={handleVisibilit} src={fechar} style={{ cursor: 'pointer' }} />
                    </div>

                    <div className="cont-input-visibilit">
                        <img src={lupa} />
                        <input  type="text" placeholder="Buscar bloco" />
                    </div>
                </div>
                <div style={{ color: '#515F75', textAlign: 'right', paddingRight: 64 }}><b>IA</b></div>

                <div className="container-blocos-mod">
                    <b>Blocos</b>
                    <div className="container-ativer-todos">
                        <span>{isCheck === true ? 'Desativar' : 'Ativar'} todos</span>
                        <PurpleSwitch
                            onChange={selectAll}
                            value="checkedA"
                            style={{ marginRight: '-8px' }}
                        />
                        <span style={{ color: '#008DFA', fontSize: 13, width: 30}}>{isCheck === true ? 'Ativo':''}</span>
                    </div>
                </div>
                <div className="container-max-blocos">
                    {a.map(a => (
                        <div key={a.id} className="container-blocos-mod bloco-cont-padding">
                            <span>{a.name}</span>
                            <div className="container-ativer-todos">
                                <PurpleSwitch
                                    checked={selectCheck.some(check => check.id === a.id)}
                                    onClick={(event) => onChangeCheck(event, a)}
                                    value={a}
                                    style={{ marginRight: '-8px' }}
                                />
                                <span style={{ color: '#008DFA', fontSize: 13, width: 30 }}>{ selectCheck.some(element => element.id === a.id) ? 'usar' : ' '}</span>

                            </div>
                        </div>
                    ))}
                </div>

                <div className="container-btn-concluir">
                    <button onClick={handleVisibilit}>concluir</button>
                </div>

            </div>
        </Modal>
    );
}
